import { Reveal, Eyebrow } from "@/components/Reveal";
import { Quote, ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/api";

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 lg:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal className="mx-auto max-w-3xl text-center">
          <Eyebrow>Testimonials</Eyebrow>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
            Words from our clients will live here.
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mx-auto mt-14 max-w-2xl rounded-3xl border border-dashed border-white/20 bg-[#0A0F1C] p-12 text-center" data-testid="testimonials-empty-state">
            <span className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-[#00F0FF]">
              <Quote size={24} />
            </span>
            <p className="text-base leading-relaxed text-slate-300 sm:text-lg">
              We're a new studio — and we only publish genuine feedback from real clients, with
              their permission. As projects are completed, their stories will appear here.
            </p>
            <p className="mt-4 text-sm text-slate-500">
              Working with us now? Your words could be the first on this wall.
            </p>
            <button
              data-testid="testimonials-cta-btn"
              onClick={() => scrollToId("contact")}
              className="group mx-auto mt-8 flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:border-[#00F0FF]/60 hover:text-[#00F0FF]"
            >
              Become our first story
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
